import React, { useState, useEffect } from "react";
import { FloatingLabel, Form, Offcanvas } from "react-bootstrap";

const FormCanvas = React.memo((props) => {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
  const [submit, setSubmit] = useState();
  const [formVal, setFormValues] = useState({});

  useEffect(() => {
    setFormValues(props.values);
  }, [props.values]);

  const inputChangeHandler = (event) => {
    const { name, checked } = event.target;

    const inputData = { ...formVal };

    if (name === "width") {
      inputData[name] = event.target.value;
    }else if (name === "min_length") {
      inputData[name] = event.target.value;
    }
     else if (name === "attribute_grid") {
      if (event.target.value <= 12) {
        inputData[name] = event.target.value;
      } else {
        return false;
      }
    } else if (name === "attribute_placeholder") {
      inputData[name] = event.target.value;
    } else if (name === "attribute_default_value") {
      inputData[name] = event.target.value;
    } else if (name === "details_pane") {
      inputData[name] = event.target.value;
    } else {
      inputData[name] = checked;
      inputData["detail_pane"] = "details";
    }
    setFormValues(inputData);
    props.onSubmit({ [name]: inputData[name] });
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        className="my-canvas"
      >
        <Offcanvas.Header closeButton className="pb-2">
          <Offcanvas.Title>Attribute Properties</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          <div className="tab-content" id="alieTabContent">
            <div className="tab-pane active" id="alieAlgorithm">
              <form>
                <div className="border-bottom pb-3">
                  <div className="title">List Settings</div>
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className="radv-title">Show In List</div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="form-check form-switch me-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          onChange={inputChangeHandler}
                          role="switch"
                          name="show_on_column"
                          value={formVal.show_on_column}
                          id="flexSwitchCheckChecked"
                          checked={formVal.show_on_column}
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckChecked"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className="radv-title">Is Sortable</div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="form-check form-switch me-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          onChange={inputChangeHandler}
                          name="sortable"
                          value={formVal.sortable}
                          id="flexSwitchCheckChecked"
                          checked={formVal.sortable}
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckChecked"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className="radv-title">Is Filterable</div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="form-check form-switch me-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="is_filter"
                          onChange={inputChangeHandler}
                          role="switch"
                          value={formVal.is_filter}
                          id="flexSwitchCheckChecked"
                          checked={formVal.is_filter}
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckChecked"
                        ></label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group mt-3">
                    <FloatingLabel label="Width">
                      <Form.Control
                        placeholder="Enter Width"
                        type="text"
                        className="form-control"
                        name="width"
                        onChange={inputChangeHandler}
                        value={formVal.width}
                      />
                    </FloatingLabel>
                  </div>
                </div>
                <div className="title mt-4">Form Settings</div>
                <div className="">
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className="radv-title">Show In Form</div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="form-check form-switch me-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="show_on_form"
                          onChange={inputChangeHandler}
                          role="switch"
                          id="flexSwitchCheckChecked"
                          value={formVal.show_on_form}
                          checked={formVal.show_on_form}
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckChecked"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className="radv-title">Is Required</div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="form-check form-switch me-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="is_required"
                          onChange={inputChangeHandler}
                          role="switch"
                          id="flexSwitchCheckChecked"
                          checked={formVal.is_required}
                        />
                        <label
                          className="form-check-label"
                          for="flexSwitchCheckChecked"
                        ></label>
                      </div>
                    </div>
                  </div>

                  {(formVal.attr_type === "select" ||
                    formVal.attribute_type === "select" ||
                    formVal.attribute_type === "api" ||
                    formVal.attr_type === "api" ||
                    formVal.attr_type === "er" ||
                    formVal.attribute_type === "monitoring" ||
                    formVal.attribute_type === "er" ||
                    formVal.attribute_type === "multi-select" ||
                    formVal.attr_type === "multi-select") && (
                    <div className="d-flex align-items-center justify-content-between mt-4">
                      <div className="radv-title">Is Multiple</div>
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="form-check form-switch me-1">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="is_multiple"
                            onChange={inputChangeHandler}
                            role="switch"
                            id="flexSwitchCheckChecked"
                            checked={formVal.is_multiple}
                          />
                          <label
                            className="form-check-label"
                            for="flexSwitchCheckChecked"
                          ></label>
                        </div>
                      </div>
                    </div>
                  )}

                  <FloatingLabel label="Default Value" className="mt-3">
                    <Form.Control
                      placeholder="Enter Width"
                      type="text"
                      className="form-control"
                      name="attribute_default_value"
                      onChange={inputChangeHandler}
                      value={formVal.attribute_default_value}
                    />
                  </FloatingLabel>
                  <div className="form-group mt-3">
                                      <FloatingLabel label="Min Length">
                                        <Form.Control
                                          placeholder="Enter Min Length"
                                          type="text"
                                          className="form-control"
                                          name="min_length"
                                          onChange={inputChangeHandler}
                                          value={formVal.min_length}
                                        />
                                      </FloatingLabel>
                                    </div>
                  <FloatingLabel label="Grid Size" className="mt-3">
                    <Form.Control
                      placeholder="Grid Size"
                      type="text"
                      className="form-control"
                      name="attribute_grid"
                      onChange={inputChangeHandler}
                      value={formVal.attribute_grid}
                    />
                  </FloatingLabel>
                </div>
                <div className="title mt-4">Details Pane</div>
                <div className="align-items-center justify-content-between w-100 mt-3">
                  <FloatingLabel label="Details Pane">
                    <Form.Select
                      placeholder="Details Pane"
                      className="form-control"
                      name="details_pane"
                      onChange={inputChangeHandler}
                      value={formVal.details_pane}
                    >
                      <option value="details">Details</option>
                      <option value="people">People's</option>
                      <option value="release_pane">Release Pane</option>
                      <option value="planning_date">Planning date</option>
                      <option value="dev_project_plan">Dev Project Plan</option>
                      <option value="qa_project_plan">Qa Project Plan</option>
                      <option value="scrum_project_plan">
                        Scrum Project Plan
                      </option>
                      <option value="status">Status</option>
                      <option value="feature">Feature</option>
                      <option value="attachment">Attachment</option>
                      <option value="priority">Priority</option>
                      <option value="title">Title</option>
                      <option value="description">Description</option>
                      <option value="invisible_pane">Invisible Pane</option>
                      <option value="long_text">Long Text</option>
                      <option value="hidden_panel">Hidden Panel</option>
                    </Form.Select>
                  </FloatingLabel>
                </div>
                <div className="title mt-4">Kanban Settings</div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Show In Kanban</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="show_in_kanban"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.show_in_kanban}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Show Group By</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="show_group_by"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.show_group_by}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="title mt-4">Attribute</div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Readonly</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="readonly"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.readonly}
                        // disabled={formVal.is_system_variable === true}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Is Editable</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="is_editable"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.is_editable}
                        // disabled={formVal.is_system_variable === true}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Bulk Update</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="bulkupdate"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.bulkupdate}
                        // disabled={formVal.is_system_variable === true}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Show Reason</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="show_reason"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.show_reason}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Show In Related</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="show_in_related"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.show_in_related}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Show In Modal</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="show_in_modal"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.show_in_modal}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Published</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="published"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.published}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Hidden Form Field</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="hidden_form_field"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.hidden_form_field}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div className="radv-title">Active</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check form-switch me-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="attribute_status"
                        onChange={inputChangeHandler}
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={formVal.attribute_status}
                        disabled={formVal.is_system_variable === true}
                      />
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckChecked"
                      ></label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
});

export default FormCanvas;
